import styled from 'styled-components'
import {spacing} from '../../theme/spacing'
import {Colors} from '../../theme/colours'
import {mediumSmallFont, smallFont} from '../../theme/font-styles'

export const Content = styled.div`
    padding: ${spacing(6)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(6)};
    width: 100%;
`

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(4)};
    background: ${Colors.grey6};
    border-radius: 4px;
    border: 1px solid ${Colors.grey10};
`

export const SectionTitle = styled.h3`
    ${mediumSmallFont()}
    margin: 0 0 ${spacing(2)} 0;
    color: ${Colors.black};
    padding-bottom: ${spacing(2)};
    border-bottom: 1px solid ${Colors.grey10};
`

export const InfoRow = styled.div`
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: ${spacing(3)};
    align-items: center;
    padding: ${spacing(2)} 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${Colors.grey10};
    }
`

export const Label = styled.span`
    ${smallFont()}
    color: ${Colors.grey14};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`

export const Value = styled.span`
    ${mediumSmallFont()}
    color: ${Colors.black};
    word-break: break-word;
`

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    align-items: flex-start;
`

export const PreferencesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    max-height: 400px;
    overflow-y: auto;
`

export const PreferenceItem = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: ${spacing(2)};
    padding: ${spacing(2)};
    background: ${Colors.white};
    border: 1px solid ${Colors.grey10};
    border-radius: 4px;
`

export const PreferenceInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    flex: 1;
    min-width: 0;
`

export const PreferenceKey = styled.span`
    ${smallFont()}
    color: ${Colors.black};
    word-break: break-word;
`

export const PreferenceValue = styled.pre`
    ${smallFont()}
    color: ${Colors.grey14};
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 200px;
    overflow-y: auto;
`
